import { HTTPAidaBaseService } from "./http";

export const GET_USER_ROLES = async (tenantId, firebaseUid) => {
  try {
    const res = await HTTPAidaBaseService.get(
      `/rbac/tenant/${tenantId}/user/${firebaseUid}/roles`
    );
    return res?.data?.roles || [];
  } catch (err) {
    console.error("Failed to fetch user roles", err);
    return [];
  }
};

export const GET_ALL_USERS = async (tenantId) => {
  try {
    const res = await HTTPAidaBaseService.get(
      `/rbac/tenant/${tenantId}/all-users`
    );
    return res?.data?.data || [];
  } catch (err) {
    console.error("Failed to fetch users", err);
    return [];
  }
};

export const CREATE_USER = async (tenantId, userData) => {
  try {
    const res = await HTTPAidaBaseService.post(
      `/rbac/tenant/${tenantId}/user/create`,
      userData
    );
    return res?.data;
  } catch (err) {
    console.error("Failed to create user", err);
    throw err;
  }
};

export const UPDATE_USER_ROLES = async (tenantId, firebaseUid, roles) => {
  try {
    const res = await HTTPAidaBaseService.put(
      `/rbac/tenant/${tenantId}/user/${firebaseUid}/update-roles`,
      { roles }
    );
    return res?.data;
  } catch (err) {
    console.error("Failed to update user roles", err);
    throw err;
  }
};

export const GET_USER_PERMISSIONS = async (tenantId, firebaseUid) => {
  try {
    const res = await HTTPAidaBaseService.get(
      `/rbac/tenant/${tenantId}/user/${firebaseUid}/permissions`
    );
    return res?.data?.permissions || [];
  } catch (err) {
    console.error("Failed to fetch user permissions", err);
    return [];
  }
};

export const DELETE_USER = async (tenantId, firebaseUid) => {
  try {
    const res = await HTTPAidaBaseService.delete(
      `/rbac/tenant/${tenantId}/user/${firebaseUid}/remove`
    );
    return res?.data;
  } catch (err) {
    console.error("Failed to delete user", err);
    throw err;
  }
};
